import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { normalizeRefCode, isValidRefCode, REF_CODE_MAX } from '../utils/refCode'

const LENGTH_MESSAGE = "Kod en az 6, en fazla 100 karakter olmalıdır.";
const IN_USE_MESSAGE = "Bu referans kodu kullanımda.";

// checkPath: user | partner | influencerPartner  (existence check endpoint)
// createPath: influencer | brand | partner | influencerPartner  (create endpoint)
function AddRefCodeDialog({ open, onClose, onCreated, token, checkPath, createPath, ownerField, ownerId }) {
  const [code, setCode] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const normalized = normalizeRefCode(code);

  useEffect(() => {
    if (open) {
      setAlertMessage("");
    }
  }, [open]);

  const reset = () => {
    setCode("");
    setAlertMessage("");
  }

  const handleClose = () => {
    reset();
    onClose();
  }

  const createCode = () => {
    return axios.post(`${process.env.REACT_APP_API_URL}api/alcago/${createPath}/createNewRefCode`,
      { [ownerField]: ownerId, ref_code: normalized },
      { params: { token } })
      .then((response) => {
        if (response && response.data.success === true && response.data.status === 201) {
          reset();
          onCreated();
        }
      })
      .catch((err) => {
        const status = err.response && err.response.status;
        if (status === 409) {
          setAlertMessage(IN_USE_MESSAGE);
        } else if (status === 400) {
          setAlertMessage(LENGTH_MESSAGE);
        } else {
          console.error(err);
        }
      })
      .finally(() => setSubmitting(false));
  }

  const addNewCode = () => {
    if (!code) {
      setAlertMessage("Lütfen kodu giriniz.");
      return;
    }
    if (!isValidRefCode(normalized)) {
      setAlertMessage(LENGTH_MESSAGE);
      return;
    }
    if (submitting) return;
    setSubmitting(true);
    axios.get(`${process.env.REACT_APP_API_URL}api/alcago/${checkPath}/checkRefCodeExists`, { params: { refCode: normalized } })
      .then((response) => {
        if (response && response.data.isExists) {
          setAlertMessage(IN_USE_MESSAGE);
        }
        setSubmitting(false);
      })
      .catch((err) => {
        if (err.response && err.response.status === 404) {
          createCode();
        } else {
          console.error(err);
          setSubmitting(false);
        }
      });
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Yeni Kod Ekle</DialogTitle>
      <DialogContent sx={{ textAlign: "center" }}>
        {alertMessage && <Alert severity="error" sx={{ mb: "20px" }}>{alertMessage}</Alert>}
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          label="Kod"
          type="text"
          value={code}
          onChange={(e) => {
            setAlertMessage("");
            setCode(e.target.value);
          }}
          inputProps={{ maxLength: 120 }}
        />
        <Typography variant="body2" mt="10px" sx={{ wordBreak: "break-all", textAlign: "left" }}>
          Kaydedilecek kod: <b>{normalized || "-"}</b> ({normalized.length}/{REF_CODE_MAX})
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="success" onClick={addNewCode} disabled={submitting} sx={{ m: "0 auto 10px auto" }}>Ekle</Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddRefCodeDialog
